import { render, staticRenderFns } from "./AuthorizationDetailsView.vue?vue&type=template&id=5b9e8440&"
import script from "./AuthorizationDetailsView.vue?vue&type=script&lang=js&"
export * from "./AuthorizationDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationDetailsView.vue?vue&type=style&index=0&id=5b9e8440&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports